

//sort dealers by tier and manual option/alpha if tied
export function sortByTier(data, type) {

   
    if (type !== 'local') {
        return data.filter(item => item.dealerTier.toLowerCase() === wtbEnum.PlatinumElite.toLowerCase())
            .sort(function (a, b) { return sorted(a, b, type) })
            .concat(data.filter(item => item.dealerTier.toLowerCase() === wtbEnum.Platinum.toLowerCase())
                .sort(function (a, b) { return sorted(a, b, type) }))
            .concat(data.filter(item => item.dealerTier.toLowerCase() === wtbEnum.Gold.toLowerCase())
                .sort(function (a, b) { return sorted(a, b, type) }))
            .concat(data.filter(item => item.dealerTier.toLowerCase() === wtbEnum.Silver.toLowerCase())
                .sort(function (a, b) { return sorted(a, b, type) }))
            .concat(data.filter(item => item.dealerTier.toLowerCase() === wtbEnum.Bronze.toLowerCase())
                .sort(function (a, b) { return sorted(a, b, type) }))
            .concat(data.filter(item => item.dealerTier.toLowerCase() === wtbEnum.None.toLowerCase())
                .sort(function (a, b) { return sorted(a, b, type) }))
            .concat(data.filter(item => item.dealerTier === "")
                .sort(function (a, b) { return sorted(a, b, type) }));
    } else {
        return data[0].dealersOrStores.filter(item => item.dealerTier.toLowerCase() === wtbEnum.PlatinumElite.toLowerCase())
            .sort(function (a, b) { return sorted(a, b, type) })
            .concat(data[0].dealersOrStores.filter(item => item.dealerTier.toLowerCase() === wtbEnum.Platinum.toLowerCase())
                .sort(function (a, b) { return sorted(a, b, type) }))
            .concat(data[0].dealersOrStores.filter(item => item.dealerTier.toLowerCase() === wtbEnum.Gold.toLowerCase())
                .sort(function (a, b) { return sorted(a, b, type) }))
            .concat(data[0].dealersOrStores.filter(item => item.dealerTier.toLowerCase() === wtbEnum.Silver.toLowerCase())
                .sort(function (a, b) { return sorted(a, b, type) }))
            .concat(data[0].dealersOrStores.filter(item => item.dealerTier.toLowerCase() === wtbEnum.Bronze.toLowerCase())
                .sort(function (a, b) { return sorted(a, b, type) }))
            .concat(data[0].dealersOrStores.filter(item => item.dealerTier.toLowerCase() === wtbEnum.None.toLowerCase())
                .sort(function (a, b) { return sorted(a, b, type) }))
            .concat(data[0].dealersOrStores.filter(item => item.dealerTier === "")
                .sort(function (a, b) { return sorted(a, b, type) }));
    }
       
    

}

const sorted = (a, b, type) => {
    switch (type) {
        case 'local':
            if (!a.manualOrderLocal) a.manualOrderLocal = "1000";
            if (!b.manualOrderLocal) b.manualOrderLocal = "1000";

            if (a.manualOrderLocal === b.manualOrderLocal) {
                return a.accountName.localeCompare(b.accountName);
            }

            return a.manualOrderLocal - b.manualOrderLocal;
        case 'intl':
            if (!a.manualOrderInternational) a.manualOrderInternational = "1000";
            if (!b.manualOrderInternational) b.manualOrderInternational = "1000";

            if (a.manualOrderInternational === b.manualOrderInternational) {
                return a.accountName.localeCompare(b.accountName);
            }

            return a.manualOrderInternational - b.manualOrderInternational;

        case 'dist':
            if (!a.manualOrderDistributor) a.manualOrderDistributor = "1000";
            if (!b.manualOrderDistributor) b.manualOrderDistributor = "1000";

            if (a.manualOrderDistributor === b.manualOrderDistributor) {
                return a.accountName.localeCompare(b.accountName);
            }

            return a.manualOrderDistributor - b.manualOrderDistributor;
        default:
            return a.accountName.localeCompare(b.accountName);
    }
}

const wtbEnum = {
    PlatinumElite: 'PlatinumElite',
    Platinum: 'Platinum',
    Gold: 'Gold',
    Silver: 'Silver',
    Bronze: 'Bronze',
    None: 'None'
}